import React from 'react';
import {
    Modal,
    Box,
    Typography,
    Button,
    List,
    ListItem,
    ListItemText,
    Divider,
    Avatar
} from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: { xs: '90%', sm: '80%', md: '700px' },
    maxHeight: '90vh',
    bgcolor: 'background.paper',
    borderRadius: '12px',
    boxShadow: 24,
    overflowY: 'auto',
    p: 4
};

const JobModal = ({ open, handleClose, job }) => {
    if (!job) return null;

    return (
        <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="job-modal-title"
            aria-describedby="job-modal-description"
        >
            <Box sx={style}>
                <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
                    <Avatar
                        src={job.logo}
                        alt={job.company}
                        sx={{ width: 80, height: 80, mr: 3 }}
                    />
                    <Box>
                        <Typography id="job-modal-title" variant="h4" component="h2" sx={{ fontWeight: 'bold' }}>
                            {job.title}
                        </Typography>
                        <Typography variant="h6" color="text.secondary">
                            {job.company}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="body1" paragraph>
                        <strong>Salaire:</strong> {job.salary}
                    </Typography>
                    <Typography variant="body1" paragraph>
                        <strong>Localisation:</strong> {job.location}
                    </Typography>
                    <Typography variant="body1" paragraph>
                        <strong>Site web:</strong> {' '}
                        <a
                            href={`https://${job.website}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#1976d2', textDecoration: 'none' }}
                        >
                            {job.website}
                        </a>
                    </Typography>
                    <Typography variant="body1" paragraph>
                        <strong>Publié:</strong> {job.postedDate}
                    </Typography>
                </Box>

                <Divider sx={{ my: 3 }} />

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
                        Description du poste
                    </Typography>
                    <Typography variant="body1" paragraph>
                        {job.description}
                    </Typography>
                </Box>

                <Box sx={{ mb: 3 }}>
                    <Typography variant="h5" sx={{ fontWeight: 'bold', mb: 2 }}>
                        Exigences
                    </Typography>
                    <List dense>
                        {job.requirements.map((req, index) => (
                            <ListItem key={index} sx={{ py: 0 }}>
                                <ListItemText primary={`• ${req}`} />
                            </ListItem>
                        ))}
                    </List>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 3 }}>
                    <Button
                        variant="contained"
                        onClick={handleClose}
                        sx={{
                            borderRadius: '20px',
                            textTransform: 'none',
                            padding: '8px 24px',
                            fontWeight: 'bold'
                        }}
                    >
                        Fermer
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default JobModal;
